import { render, staticRenderFns } from "./UserInfoRoute.vue?vue&type=template&id=52b61471&scoped=true&"
import script from "./UserInfoRoute.vue?vue&type=script&lang=js&"
export * from "./UserInfoRoute.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoRoute.vue?vue&type=style&index=0&id=52b61471&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b61471",
  null
  
)

export default component.exports